import { Filter, OrderBy } from '@shared/types';

export function getFilteredFieldSets(filters: Filter[], orFilters: Filter[]) {
  const andFields = new Set(filters.map((f) => f.field));
  const orFields = new Set(orFilters.map((f) => f.field));
  return { andFields, orFields };
}

/** Display column __id__ maps to query field __name__. */
export function isFieldFiltered(
  field: string,
  andFields: Set<string>,
  orFields: Set<string>
): boolean {
  const checkField = field === '__id__' ? '__name__' : field;
  return andFields.has(checkField) || orFields.has(checkField);
}

export function computeNextSort(currentSort: OrderBy | null, field: string): OrderBy {
  if (currentSort?.field === field) {
    return {
      field,
      direction: currentSort.direction === 'asc' ? 'desc' : 'asc',
    };
  }
  return { field, direction: 'asc' };
}
